import { API_BASE_URL } from "src/config/apiBase";
import { Search } from "lucide-react";
import React, { useEffect, useState } from "react";
import { decryptToken } from "../utils/getToken";
import { getDecryptedUserFromCookie } from "../utils/getCookie";



const Author = () => {
    const [categories, setCategories] = useState([]);
    const [categoryFilter, setCategoryFilter] = useState(""); // store selected category
    const [name, setName] = useState("");
    const [parent, setParent] = useState("");
    const [slug, setSlug] = useState("");
    const [activeTab, setActiveTab] = useState("All");
    const [search, setSearch] = useState("");
    const [selected, setSelected] = useState([]); // Track selected category IDs
    const [editingCategory, setEditingCategory] = useState(null); // holds category being edited
    const [isEditing, setIsEditing] = useState(false); // toggle form mode

    const token = decryptToken("accessToken") || ""
    const isLoggedIn = getDecryptedUserFromCookie("gta_mainstateuser");
    const url = API_BASE_URL
    // Filter categories based on search and active tab
    // Filter categories based on search and active tab




    // Checkbox logic

    // Bulk trash action
    // 🧹 Bulk Delete
    // 🗑️ Bulk Trash
    const handleBulkTrash = async () => {
        if (selected.length === 0) return;
        if (!window.confirm("Move selected categories to trash?")) return;

        try {
            const response = await fetch(`${url}/blog-author/bulk/trash`, {
                method: "PATCH",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ ids: selected, trash: true }),
            });

            if (response.ok) {
                setCategories((prev) =>
                    prev.map((cat) =>
                        selected.includes(cat.id)
                            ? { ...cat, trash: true }
                            : cat
                    )
                );
                setSelected([]);
            } else {
                const err = await response.json();
                console.error("Bulk trash error:", err.message);
            }
        } catch (error) {
            console.error("Error bulk trashing categories:", error);
        }
    };

    // // ♻️ Bulk Restore
    const handleBulkRestore = async () => {
        if (selected.length === 0) return;
        if (!window.confirm("Restore selected categories from trash?")) return;

        try {
            const response = await fetch(`${url}/blog-author/bulk/trash`, {
                method: "PATCH",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ ids: selected, trash: false }),
            });

            if (response.ok) {
                setCategories((prev) =>
                    prev.map((cat) =>
                        selected.includes(cat.id)
                            ? { ...cat, trash: false }
                            : cat
                    )
                );
                setSelected([]);
            } else {
                const err = await response.json();
                console.error("Bulk restore error:", err.message);
            }
        } catch (error) {
            console.error("Error bulk restoring categories:", error);
        }
    };


    const fetchData = async () => {
        try {
            const response = await fetch(`${url}/blog-author`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });
            const res = await response.json();
            setCategories(res.data);
        } catch (error) {
            console.log(error);
        }
    }

    console.log(parent)

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!name.trim()) return;

        const payload = {
            title: name,
            // parent_id: parent ? (parent) : null,
            // slug: slug || name.toLowerCase().replace(/\s+/g, "-"),
            // status: "published",
        };

        try {
            let response, res;

            if (isEditing && editingCategory) {
                // 🔹 Update existing category
                response = await fetch(`${url}/blog-author/${editingCategory.id}`, {
                    method: "PUT",
                    headers: { "Content-Type": "application/json",
                        "Authorization":`Bearer ${token}`
                     },
                    body: JSON.stringify(payload),
                });
                res = await response.json();

                if (response.ok) {
                    setCategories(
                        categories.map((cat) =>
                            cat.id === editingCategory.id ? { ...cat, ...payload } : cat
                        )
                    );
                }
            } else {
                // 🔹 Add new category
                response = await fetch(`${url}/blog-author`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json",
                        "Authorization":`Bearer ${token}`
                     },
                    body: JSON.stringify(payload),
                });
                res = await response.json();

                if (response.ok) {
                    setCategories([...categories, res.data || payload]);
                }
            }

            // ✅ Reset form
            setName("");
            setParent("");
            setSlug("");
            setEditingCategory(null);
            setIsEditing(false);
        } catch (error) {
            console.error(error);
        }
    };


    // 🗑️ Single Delete
    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure you want to permanently delete this category?")) return;

        try {
            const response = await fetch(`${url}/blog-author/${id}`, {
                method: "DELETE",
                headers:{
                    "Authorization":`Bearer ${token}`
                }
            });

            if (response.ok) {
                setCategories((prev) => prev.filter((cat) => cat.id !== id));
            } else {
                const err = await response.json();
                console.error("Error deleting :", err.message);
            }
        } catch (error) {
            console.error("Error deleting :", error);
        }
    };


    const handleTrash = async (id) => {
        try {
            const response = await fetch(`${url}/blog-author/${id}/trash`, {
                method: "PATCH",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ trash: true }),
            });

            if (response.ok) {
                setCategories((prev) =>
                    prev.map((item) =>
                        item.id === id
                            ? { ...item, trash: true }
                            : item
                    )
                );
            } else {
                const err = await response.json();
                console.error("Error:", err.message);
            }
        } catch (error) {
            console.error("Error trashing category:", error);
        }
    }

    // 🧹 Bulk Delete
    const handleBulkDelete = async () => {
        if (selected.length === 0) return;
        if (!window.confirm("Are you sure you want to permanently delete selected categories?")) return;

        try {
            const response = await fetch(`${url}/blog-author/bulk`, {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ ids: selected }),
            });

            if (response.ok) {
                setCategories((prev) =>
                    prev.filter((cat) => !selected.includes(cat.id))
                );
                setSelected([]);
            } else {
                const err = await response.json();
                console.error("Error bulk deleting:", err.message);
            }
        } catch (error) {
            console.error("Error bulk deleting categories:", error);
        }
    };


    const handleRestore = async (id) => {
        try {
            const response = await fetch(`${url}/blog-author/${id}/trash`, {
                method: "PATCH",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ trash: false }),
            });

            if (response.ok) {
                setCategories((prev) =>
                    prev.map((item) =>
                        item.id === id
                            ? { ...item, trash: false }
                            : item
                    )
                );
            }
        } catch (error) {
            console.error("Error restoring category:", error);
        }
    }

    const filteredCategories = categories.filter((cat) => {
        const matchesSearch = cat.title.toLowerCase().includes(search.toLowerCase());
        const matchesTab =
            (activeTab === "All")
        // (activeTab === "Published" && cat.status === "published" && !cat.trash) ||
        // (activeTab === "Trashed" && cat.trash);

        // const matchesCategoryFilter = categoryFilter
        //     ? cat.name === categoryFilter || cat.parentDetails?.name === categoryFilter
        //     : true;

        return matchesSearch && matchesTab;
    });


    const allSelected = filteredCategories.length > 0 && filteredCategories.every((cat) => selected.includes(cat.id));
    const someSelected = filteredCategories.some((cat) => selected.includes(cat.id)) && !allSelected;

    const toggleSelectAll = () => {
        if (allSelected) {
            setSelected([]); // Deselect all
        } else {
            setSelected(filteredCategories.map((cat) => cat.id)); // Select all visible categories
        }
    };

    const toggleSelectOne = (id) => {
        if (selected.includes(id)) {
            setSelected(selected.filter((selectedId) => selectedId !== id));
        } else {
            setSelected([...selected, id]);
        }
    };


    useEffect(() => {
        fetchData();
    }, [])

    return (
        <div className="p-4">
            {/* Tabs + Search Bar */}
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-4">
               
                {/* Search */}
                <div className="relative w-64">
                    <Search
                        size={18}
                        className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
                    />
                    <input
                        type="text"
                        placeholder="Search author..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        className="w-full pl-10 pr-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-1 focus:ring-indigo-500 focus:outline-none"
                    />
                </div>
            </div>

            {/* Filters below header */}
            <div className="flex items-center justify-between mb-4">
                <div className="flex gap-3 items-center text-sm">
                    {/* Filter by Category */}


                </div>

                <div className="text-sm text-gray-600">
                    Showing {filteredCategories.length} author
                </div>
            </div>

            <div className="flex flex-col-reverse lg:flex-row gap-6">
                {/* LEFT - Categories Table */}
                <div className="w-full lg:flex-[2] bg-white shadow rounded-lg overflow-hidden">
                    <div className="overflow-x-auto">
                        <table className="w-full table-auto">
                            <thead className="bg-[#f9f9f9] text-gray-900">
                                <tr>
                                    {/* <th className="px-4 py-3 text-left w-12">
                                        <label className="inline-flex items-center">
                                            #
                                        </label>
                                    </th> */}
                                    <th className="px-4 py-3 text-left text-sm font-medium tracking-wider">Name</th>

                                </tr>
                            </thead>
                            <tbody className="divide-y">
                                {filteredCategories.map((cat) => (
                                    <tr key={cat.id} className="group hover:bg-gray-50 transition border-b border-gray-200">
                                        {/* <td className="px-4 py-2">
                                            <label className="inline-flex items-center">
                                               {cat.id}
                                            </label>
                                        </td> */}
                                        <td className="px-4 py-2 text-sm text-gray-700 flex flex-col">
                                            <div>
                                                {cat.title}
                                            </div>
                                            <div className="min-h-[1.25rem] opacity-50 group-hover:opacity-100 transition-opacity mt-1 flex items-center gap-2 text-xs">
                                                {
                                                    isEditing ?
                                                        <button
                                                            type="button"
                                                            onClick={() => {
                                                                setIsEditing(false);
                                                                setEditingCategory(null);
                                                                setName("");
                                                                setParent("");
                                                                setSlug("");
                                                            }}
                                                            className="cursor-pointer text-gray-500 hover:text-indigo-600 font-medium"
                                                        >
                                                            Cancel Edit
                                                        </button> :
                                                        <button className="cursor-pointer text-gray-500 hover:text-indigo-600 font-medium"
                                                            onClick={() => {
                                                                setIsEditing(true);
                                                                setEditingCategory(cat);
                                                                setName(cat.title);

                                                            }}
                                                        >
                                                            Edit
                                                        </button>
                                                }

                                                <span className="h-3 w-px bg-gray-300"></span>

                                                {/* {
                                                    cat.trash === true ? <button
                                                        onClick={() => handleRestore(cat.id)}
                                                        className="cursor-pointer text-gray-500 hover:text-green-600 font-medium">
                                                        Restore
                                                    </button> : <button className="cursor-pointer text-gray-500 hover:text-green-600 font-medium">
                                                        View
                                                    </button>
                                                } */}
                                                <span className="h-3 w-px bg-gray-300"></span>
                                                {/* {
                                                    cat.trash === true ?
                                                        <button
                                                            onClick={() => handleDelete(cat.id)}
                                                            className="cursor-pointer text-red-600 font-medium">
                                                            Delete
                                                        </button> :
                                                        <button
                                                            onClick={() => handleTrash(cat.id)}
                                                            className="cursor-pointer text-red-600 font-medium">
                                                            Trash
                                                        </button>
                                                } */}
                                                <button
                                                    onClick={() => handleDelete(cat.id)}
                                                    className="cursor-pointer text-red-600 font-medium">
                                                    Delete
                                                </button>
                                            </div>
                                        </td>
                                        {/* <td className="px-4 py-2 text-sm text-gray-700">{cat.parentDetails?.name || ""}</td>
                                        <td className="px-4 py-2 text-sm text-gray-700">{cat.slug}</td>
                                        <td className="px-4 py-2 text-sm text-gray-700">{cat.count}</td> */}
                                    </tr>
                                ))}
                                {filteredCategories.length === 0 && (
                                    <tr>
                                        <td colSpan={5} className="px-4 py-6 text-center text-gray-500">
                                            No author found.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* RIGHT - Add Category Form */}
                <div className="bg-white shadow rounded-lg p-4 w-full lg:w-80">
                    <h2 className="text-lg font-semibold mb-4">{
                        isEditing ? "Update Author" : "Add New Author"}</h2>
                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div>
                            <label className="block text-sm font-medium mb-1">Name</label>
                            <input
                                type="text"
                                value={name}
                                onChange={(e) => {
                                    const newName = e.target.value;
                                    setName(newName);
                                    // setSlug(
                                    //     newName
                                    //         .toLowerCase()
                                    //         .trim()
                                    //         .replace(/\s+/g, "-") // Replace spaces with dashes
                                    //         .replace(/[^a-z0-9-]/g, "") // Remove special characters
                                    // );
                                }}
                                placeholder="Author name"
                                className="w-full border-b-2 border-gray-300 focus:border-indigo-500 outline-none py-2 transition text-sm sm:text-base"
                            />
                        </div>





                        <button
                            type="submit"
                            className="w-full p-2 text-sm rounded-full text-white font-semibold bg-gradient-to-r from-blue-500 to-blue-800 hover:from-blue-600 hover:to-blue-900 transition-colors duration-300"
                        >
                            {isEditing ? "Update Author" : "Add Author"}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Author;